
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"26","height":"26"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.188 6.016h-5.391c-.813 0-.813-.813-.813-.813v-1.36a.812.812 0 00-.812-.812H7.812A.812.812 0 007 3.844v1.36s0 .812-.813.812H.813A.812.812 0 000 6.828v15.36c0 .449.363.812.813.812h24.375c.449 0 .812-.363.812-.813V6.829a.812.812 0 00-.813-.812zM23 10.258A1.26 1.26 0 0121.742 9 1.26 1.26 0 0123 7.742 1.26 1.26 0 0124.258 9 1.26 1.26 0 0123 10.258zM13 21.12A7.123 7.123 0 015.879 14 7.123 7.123 0 0113 6.879 7.123 7.123 0 0120.121 14 7.12 7.12 0 0113 21.121zm0-1.664a5.457 5.457 0 110-10.914 5.457 5.457 0 010 10.914z"}})])
          )
        }
      }
    